export default __webpack_public_path__ + "static/media/new-logo.5fd890c3.png";